import { Component, OnInit, Input } from '@angular/core';
import { IconService } from './icon.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss']
})
export class IconComponent implements OnInit {
  @Input() button;
  @Input() height;
  lastSrc;
  @Input() src;
  svgContent = '' as SafeHtml;
  @Input() width;

  constructor(private service: IconService, private sanitizer: DomSanitizer) { }

  ngOnInit() {
    this.getSrc();
    this.lastSrc = this.src;
  }

  ngOnChanges() {
    if (typeof this.button === 'string') {
      this.button = true;
    }
    if (this.lastSrc !== this.src) {
      this.getSrc();
      this.lastSrc = this.src;
    }
  }

  getSrc() {
    if (!this.src) {
      this.svgContent = '';
      return;
    }
    this.service.getSvg(this.src).then(result => {
      this.svgContent = this.sanitizer.bypassSecurityTrustHtml(result);
    });
  }
}
